<template>
  <div id="basic">
    <div class="top_div">
      <el-form :inline="true" :model="formInline">
        <el-form-item label="请选择门店" style="margin-right:20px">
          <el-select v-model="formInline.shop_id" placeholder="请选择" @change="getList">
            <el-option
              v-for="index in typeDate"
              v-bind:key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="demo-form-inline">
          <el-form-item label="按起止时间:">
            <el-date-picker
              v-model="formInline.date"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="formInline.status" placeholder="请选择">
             <el-option
               
                label="不限制"
                value=""
              ></el-option>
              <el-option
                v-for="index in statusList"
                v-bind:key="index.id"
                :label="index.value"
                :value="index.key_name"
              ></el-option>
            </el-select>
          </el-form-item>

           <el-form-item label="外卖类型">
            <el-select v-model="formInline.takeout_type" placeholder="请选择">
              <el-option
                v-for="index in orderstatusList"
                v-bind:key="index.id"
                :label="index.name"
                :value="index.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="微信昵称">
            <el-input v-model="formInline.client_nick_name"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="formInline.mobile"></el-input>
          </el-form-item>
        </div>

        <div class="bottom_center">
          <el-form-item style="min-width: 150px;">
            
            <el-button type="primary" style="background: #1890ff;" @click="getList">查询</el-button>
            <el-button type="primary" class="vubutton" @click="onSubmit">重置</el-button>
           <download-excel
              :fetch="fetchData"
              :fields="json_fields"
              :before-generate="startDownload"
              name="外卖订单列表.xls"
              style="display: inline-block; margin-left: 10px"
            >
              <el-button
                type="primary"
                :loading="upload"
                style="
                  background: #1baeae;
                  color: #fff;
                  border: none;
                  height: 40px;
                "
                >导出</el-button
              >
            </download-excel>
         </el-form-item>
        </div>
      </el-form>
       <el-row :gutter="10">
          <el-col :span="3">
            <div class="top-title">总订单数</div>
            <div class="top-numnber">{{ total }}</div>
          </el-col>
          <el-col :span="3">
            <div class="top-title">合计金额</div>
            <div class="top-numnber">{{ totalamount  / 100 }}</div>
          </el-col>
        </el-row>


      <el-table
        :fit="false"
        border
        :data="tableData"
        style="width: auto;"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>
        <el-table-column label="订单编号" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户名" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.client_nick_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系方式" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>
        


       <el-table-column label="外卖类型" width="180">
         <template slot-scope="scope">
           <span>{{ scope.row.takeout_type }}</span>
         </template>
       </el-table-column>
<!--        <el-table-column label="订单备注" width="180">-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ scope.row.desc }}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="预定手机号" width="180">-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ scope.row.book_mobile }}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="联系方式" width="180">-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ scope.row.book_mobile }}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="微信用户名" width="180">-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ scope.row.client_nick_name }}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="订单状态" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column label="总金额" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.total_price  }}元</span>
          </template>
        </el-table-column>
        <el-table-column label="支付方式" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.pay_type }}</span>
          </template>
        </el-table-column>
<!--        <el-table-column label="微信支付金额" width="180">-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ scope.row.pay_price/100 }}元</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="余额支付金额" width="180">-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ scope.row.prepay_price/100 }}元</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="折扣金额" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.discount_price }}元</span>
          </template>
        </el-table-column>
<!--        <el-table-column label="优惠券名称" width="180">-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ scope.row.coupon_name }}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="配送费" width="180">-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ scope.row.deliver_fee/100 }}元</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="包装" width="180">-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ scope.row.box_fee/100 }}元</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <button :key="scope.id" @click="setdialogFormVisible(scope.row.id)">查看</button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="pageSize"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="page_size"
      ></el-pagination>
      <el-dialog title="详细信息" :visible.sync="dialogFormVisible">
        <el-form :model="form">
          <el-form-item label="名称：" :label-width="formLabelWidth">
            <div>{{form.name}}</div>
          </el-form-item>
          <el-form-item label="用户名：" :label-width="formLabelWidth">
            <div>{{form.client_nick_name}}</div>
          </el-form-item>
          <el-form-item label="备注：" :label-width="formLabelWidth">
            <div>{{form.desc}}</div>
          </el-form-item>
          <el-form-item label="订单类型：" :label-width="formLabelWidth">
            <div>{{form.order_type}}</div>
          </el-form-item>
          <el-form-item label="状态：" :label-width="formLabelWidth">
            <div>{{form.status}}</div>
          </el-form-item>
          <el-form-item label="支付方式：" :label-width="formLabelWidth">
            <div>{{form.pay_type}}</div>
          </el-form-item>
          <el-form-item label="配送方式：" :label-width="formLabelWidth">
            <div>{{form.takeout_type}}</div>
          </el-form-item>
          <el-form-item label="配送信息：" :label-width="formLabelWidth" v-if="form.client_address">
            <div>地址：{{form.client_address.address_to_building}}{{form.client_address.address_to_floor}}</div>
            <div>联系人：{{form.client_address.name}} {{form.client_address.gender}} {{form.client_address.mobile}}</div>
          </el-form-item>
          <el-form-item
            label="商品信息"
            :label-width="formLabelWidth"
            v-if="form.takeout_order_details"
          >
            <div v-for="item in form.takeout_order_details" :key="item.id">
              <div>商品名称：{{item.name}}</div>
              <div style="margin-left:20px" v-if="item.sale_attrs">加料：{{item.sale_attrs}}</div>
              <div style="margin-left:20px">数量：{{item.amount}}</div>
              <div
                style="margin-left:20px"
              >规格：{{item.unit_price/100}}元/{{item.unit_amount}}{{item.unit_name}}</div>
              <div style="margin-left:20px">总价：{{item.total_price/100}}元</div>
            </div>
          </el-form-item>
          <el-form-item label="总金额：" :label-width="formLabelWidth">
            <div>{{form.total_price/100}}元</div>
          </el-form-item>
          <el-form-item label="余额支付金额：" :label-width="formLabelWidth">
            <div>{{form.prepay_price/100}}元</div>
          </el-form-item>
          <el-form-item label="微信支付金额：" :label-width="formLabelWidth">
            <div>{{form.pay_price/100}}元</div>
          </el-form-item>
          <el-form-item label="优惠券折扣金额：" :label-width="formLabelWidth">
            <div>{{form.discount_price/100}}元</div>
          </el-form-item>
          <el-form-item label="优惠券名称：" :label-width="formLabelWidth">
            <div>{{form.coupon_name}}</div>
          </el-form-item>
          <el-form-item label="配送费：" :label-width="formLabelWidth">
            <div>{{form.deliver_fee/100}}元</div>
          </el-form-item>
          <el-form-item label="开始时间：" :label-width="formLabelWidth">
            <div>{{form.created_at}}</div>
          </el-form-item>
          <el-form-item label="结束时间：" :label-width="formLabelWidth">
            <div>{{form.deleted_at}}</div>
          </el-form-item>

          <!-- book_mobile: "13900010001"
book_time: ""
box_fee: 200
client_address: {id: 130497272430848, created_at: "2020-08-20T17:42:41+08:00", updated_at: "2020-08-20T17:45:15+08:00",…}
client_address_id: 130497272430848
client_coupon_id: 0
client_id: 48685619479040
client_nick_name: "YUZH"
takeout_order_details: [,…]
          updated_at: "2020-09-01T21:57:09+08:00"-->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="noStatus()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date';

export default {
  name: 'employee',
  data() {
    return {
      typeDate: [],
      formInline: {},
       json_fields: {
             门店: 'shop_name',
        门店id: 'shop_id',
        ID: 'id',
         订单时间: 'created_at',
           商品名: 'name',
        用户名: 'client_nick_name',
            手机号: 'mobile',
      外卖类型: 'takeout_type',
        状态: 'status',
        总金额: 'total_price', //如果命名的标题有空格,需要用双引号
        支付方式: 'pay_type',
      
          折扣金额: 'discount_price',
          
       
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      statusList: [],
      orderstatusList:[
        {
        name:'不限制',
        value:''
      },{
        name:'配送',
        value:'deliver'
      },
      {
        name:'自取',
        value:'instore'
      }],
      tableData: [],
      dialogFormVisible: false,
      form: {},
      formLabelWidth: '200px',
      total: 0,
       totalamount: 0,
       upload: false,
      page_size: 20,
      page_no: 1,
    };
  },
  methods: {
      startDownload() {
      this.upload = true;
      // alert('show loading');
      },
     async fetchData() {
      const shopValue = this.typeDate.find(
        (item) => item.id === this.formInline.shop_id
      );
    if(!this.formInline.date || !this.formInline.date[0] || !this.formInline.date[1]){
       this.$alert('请选择时间')
       this.upload = false;
      return;
    }
     let statedate=new Date(this.formInline.date[0]),enddate=new Date(this.formInline.date[1]);
     if((enddate.getTime() - statedate.getTime()) > 7776000000){
        this.$alert('仅支持导出3个月订单');
        this.upload = false;
       return
     }
      //  console.log( '更新：',this.formInline.date);
     
     
      // const data = {
      //   shop_id: shopValue.id,
      //   plate_no: this.formInline.plate_no || '',
      //   mobile: this.formInline.mobile,
      //   pay_type: this.formInline.pay_type,
      //   status: this.formInline.status || '',
      //   start_date: (this.formInline.date && this.formInline.date[0]) || '',
      //   end_date: (this.formInline.date && this.formInline.date[1]) || '',
      //   page_index: this.page_no,
      //   page_size: this.tabPage.count,
      // };
       const url = this.$userList.user_order_takeout_search;
      const data = {
        shop_id: shopValue.id,
        client_nick_name: this.formInline.client_nick_name || '',
        mobile: this.formInline.mobile,
        takeout_type:this.formInline.takeout_type,
        status: this.formInline.status || '',
        // start_date: (this.formInline.date && this.formInline.date[0]) || '',
        // end_date: (this.formInline.date && this.formInline.date[1]) || '',
        page_index: 1,
        page_size: this.total,
      };
       if(this.formInline && this.formInline.date && this.formInline.date.length>0){
            data.start_date=fecha.format(
              new Date(this.formInline.date[0]),
              'yyyy-MM-dd HH:mm:ss'
            )
              data.end_date=fecha.format(
              new Date(this.formInline.date[1]),
              'yyyy-MM-dd HH:mm:ss'
            )
        }
      console.log(data);
      let tableData=[] || []
       let res= await this.$http.post(url, data);
        tableData = res.data.items || [];
        tableData.forEach((item)=>{
        item.total_price=item.total_price / 100;
         item.discount_price=item.discount_price / 100;
        
        //  item.id=item.id + '';
        
          item.updated_at = fecha.format(
              new Date(item.updated_at),
              'yyyy-MM-dd HH:mm:ss'
            );
          item.created_at = fecha.format(
              new Date(item.created_at),
              'yyyy-MM-dd HH:mm:ss'
            );
        })
        // this.tableData = res.data.items;
          // this.total = res.data.count;
          // this.tabPage = res.data;

        this.upload = false;
        return tableData;

    },
    pageSize(index) {
      this.page_no = index;
      this.getList();
    },
    noStatus() {
      this.dialogFormVisible = false;
    },
    setdialogFormVisible(id) {
      console.log(id);
      const url = this.$userList.user_order_takeout_detail + `/` + id;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          let data = res.data;
          // data.map(item => {
          data.created_at = fecha.format(
            new Date(data.created_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          data.updated_at = fecha.format(
            new Date(data.updated_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          // });
          (data.takeout_type =
            (data.takeout_type == 'deliver' && '配送') || '自取'),
            (this.form = data);
          this.dialogFormVisible = true;

          console.log(data);
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    onSubmit() {
      console.log('submit!');
      const shop_id = this.formInline.shop_id;
      this.formInline = {
        shop_id,
      };
      this.getList();
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    //获取门店
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.typeDate = res.data.items;
          this.formInline.shop_id = res.data.items[0].id;
          this.getList();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    //通用状态
    getCommonData() {
      const url = this.$userList.user_common_data + `/order_status`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          console.log(res.data);
          this.statusList = res.data;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    getList() {
      const shopValue = this.typeDate.find(
        item => item.id === this.formInline.shop_id
      );
      console.log(shopValue);
      const url = this.$userList.user_order_takeout_search;
    
      const data = {
        shop_id: shopValue.id,
        client_nick_name: this.formInline.client_nick_name || '',
        mobile: this.formInline.mobile,
        takeout_type:this.formInline.takeout_type,
        status: this.formInline.status || '',
        start_date:  '',
        end_date:  '',
        page_index: this.page_no,
        page_size: this.page_size,
      };

        // let statedate=fecha.format(
        //       new Date(this.formInline.date[0]),
        //       'yyyy-MM-dd HH:mm:ss'
        //     ),enddate=fecha.format(
        //       new Date(this.formInline.date[1]),
        //       'yyyy-MM-dd HH:mm:ss'
        //     );
            if(this.formInline && this.formInline.date && this.formInline.date.length>0){
                data.start_date=fecha.format(
                  new Date(this.formInline.date[0]),
                  'yyyy-MM-dd HH:mm:ss'
                )
                 data.end_date=fecha.format(
                  new Date(this.formInline.date[1]),
                  'yyyy-MM-dd HH:mm:ss'
                )
            }
      this.$http.post(url, data).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.items.map(item=> {
              item.total_price=item.total_price / 100;
                  item.discount_price=item.discount_price / 100;
            item.created_at = fecha.format(
                new Date(item.created_at),
                'yyyy-MM-dd HH:mm:ss'
            );
            return item;
          })
          this.total = res.data.count;
          this.totalamount=res.data.total_amount || 0;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
  },
  created() {
    this.$root.setheadName();
    this.getType();
    this.getCommonData();
    // this.rows();
    // this.getMuList();
  },
};
</script>

<style   scoped>
#basic {
  width: 100%;
  height: 100%;
  position: relative;
}

.top_div {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
}

.demo-form-inline {
  display: flex;
  justify-content: flex-start;
}

/* .el-select > .div,
.el-input__inner {
  width: 300px;
} */
.vubutton {
  background: #fff;
  border: solid 1px #1890ff;
  color: #1890ff;
}

.center_div {
  margin-top: 20px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}

.center_div_border {
  margin-top: 20px;
  width: 100%;
  min-height: 300px;
  background: brown;
}

.bottom_center {
  width: 100%;
  display: flex;
  justify-content: space-between;
}


.top-title {
  font-weight: 400;
  color: #606266;
  font-size: 14px;
}
.top-numnber {
  font-weight: 700;
  line-height: 40px;
  font-size: 23px;
}
</style>
